
import React from "react";
import { Label } from "@/components/ui/label";
import { FormFieldType } from "@/types/form";
import { Info } from "lucide-react";
import { Popover, PopoverTrigger, PopoverContent } from "@/components/ui/popover";
import { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider } from "@/components/ui/tooltip";

interface FieldLabelWithInfoProps {
  element: FormFieldType;
  infoContent?: React.ReactNode;
}

export const FieldLabelWithInfo: React.FC<FieldLabelWithInfoProps> = ({ element, infoContent }) => {
  if (!element.label) return null;
  
  return (
    <div className="mb-2 flex items-center gap-2">
      <Label htmlFor={element.id} className="block text-sm font-medium">
        {element.label}
        {element.required && <span className="text-red-500 ml-1">*</span>}
      </Label>
      
      {infoContent && (
        <Popover>
          <TooltipProvider>
            <Tooltip>
              <TooltipTrigger asChild>
                <PopoverTrigger asChild>
                  <button className="rounded-full p-0.5 text-gray-400 hover:text-gray-600 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-500/50">
                    <Info className="h-4 w-4" />
                  </button>
                </PopoverTrigger>
              </TooltipTrigger>
              <TooltipContent>
                <p className="text-xs">คลิกเพื่อดูรายละเอียด</p>
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
          
          <PopoverContent className="w-100 p-0 max-h-[80vh] overflow-y-auto shadow-lg border-gray-200">
            <div className="p-4 bg-white rounded-md">
              {infoContent}
            </div>
          </PopoverContent>
        </Popover>
      )}
      
      {element.description && (
        <p className="text-sm text-gray-500 mt-1 whitespace-pre-line">{element.description}</p>
      )}
    </div>
  );
};

export default FieldLabelWithInfo;
